import permissions from '../permissions'

const PRIVACY_PORTAL_THEME_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.VISUALIZE,
    tag: permissions.PRIVACY_PORTAL_THEMES.SHOW,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.MANAGE,
    tag: permissions.PRIVACY_PORTAL_THEMES.MANAGE,
  },
]

export default PRIVACY_PORTAL_THEME_LIST
